import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ArbreComposant } from 'src/app/model/arbre/arbre-composant';
import { EditArbreComponent } from '../edit-arbre/edit-arbre.component';
import { MatDialog } from '@angular/material/dialog';
import { TreeService } from 'src/app/services/http/tree/tree.service';

@Component({
  selector: 'app-arbre-component',
  templateUrl: './arbre-component.component.html',
  styleUrls: ['./arbre-component.component.scss']
})
export class ArbreComponentComponent implements OnInit {
  @Input() composant! : ArbreComposant;
  /** Is the component being displayed for edition ? */
  @Input() forEdition! : boolean;
  /**
   * Event emitted to calls-verif component when showing tree during a call
   */
  @Output() composantEvent = new EventEmitter<ArbreComposant[]>();

  @Input() showAll!: boolean;
  
  @Output() reloadEvent = new EventEmitter<boolean>();


  //public showAll: boolean = false;
  public children! :ArbreComposant[];
  public shownId : number = 0;
  constructor(public dialog : MatDialog, public treeService: TreeService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
      this.getChildren();
  }

  selectComposant(event: any, selected: ArbreComposant) {
    event.stopPropagation();
    selected = Object.assign({}, selected); /** Check if mandatory */
    this.emitEvent(selected);
  }

  emitEvent(composant: ArbreComposant){
    this.treeService.addComposantToSelection(composant);
    this.composantEvent.emit( this.treeService.getCurentSelection() );   
  }

  emitReloadEvent(){
    this.reloadEvent.emit( true );   
  }

  /**
   * Open the Component Editor passing it current component and it's parent (mandatory ..? )
   * @param event 
   * @param component 
   * @param parent 
   */
  edit( event: any, component: ArbreComposant, parent: ArbreComposant): void{
    event.stopPropagation();
    // console.log(component);
    const dialogRef = this.dialog.open(EditArbreComponent,{
      data: {
        composant : component,
        parent: parent,
        edition: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if( result && result.data){
        this.composant = result.data;
        /** Emit an event so that arbre-management component knows it has to refresh */
        // Pas besoin de rafraichissement, les modifications appraissent @since #104
        // this.emitReloadEvent();
      }
    });

  }
 
  show( event: any, id: number ){
    event.stopPropagation();
    console.log(id);
    if( this.shownId != id ){
      this.shownId = id; 
    }else{
      this.shownId = 0;
    }
  }

  getChildren() {
    this.treeService.getChildren( this.composant ).then( children =>{
      this.children = children;
    })
  }

  getComposants() {
    this.treeService.getComposantsByIds( this.composant.children_id ).subscribe( children =>{
      this.children = children;
    })
  }

  newElement(  event: any, component: ArbreComposant ){
    event.stopPropagation();
    // @since #104 - on ferme le noeud actuel (pour éviter le refresh complet du composant)
    this.show(event, component.id);
    const data =  {
      edition: false,
      iamroot: false,
      forcedType: component.children_type,
      parent: component
    };

    const dialogRef = this.dialog.open(EditArbreComponent,{
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if( result && result.data){
        this.composant = result.data;
        this.show(event, component.id);
        // @since #104 - on ouvre à nouveau le noeud, ce qui permet de charger l'enfant qu'on vient de créer
        // Et on ne reload pas le tout complètement
        /** Emit an event so that arbre-management component knows it has to refresh */
        // this.emitReloadEvent();
      }
    });

  }
}
